import styled from 'styled-components';
import { DARK_SKY } from '../../theme';

const AppContainer = styled.div`
  min-height: 100%;
  background-color: ${DARK_SKY};
  font-family: Roboto, sans-serif;
`;

const Content = styled.div`
  display: flex;
  min-height: calc(100vh - 3rem);
  @media (max-width: 37.5rem) {
    min-height: calc(100vh - 3.125rem);
  }
`;

export { AppContainer, Content };